import styled from 'styled-components';

export const ItemPlaceholder = styled.div`
    background: rgb(230, 230, 230);
    background: linear-gradient(
        180deg,
        rgba(230, 230, 230, 1) 0%,
        rgba(236, 236, 240, 1) 43%,
        rgba(249, 249, 249, 1) 100%
    );
    min-height: 250px;
`;
